import React, { useEffect } from 'react'
import Header from '../Header/Header'
import Nav from '../Header/Nav'
import SearchContent from './SearchContent' // This is the component above
import Footer from '../Footer/Footer'
import WhatssapIcon from '../Home/WhatssapIcon'

const SearchPage = () => {

    useEffect(() => {
        // This is more reliable for sticky headers
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, []);

    return (
        <div className="flex flex-col min-h-screen">
            <Header />

            {/* We keep the Nav, target can be left blank or set to 'search' */}
            <Nav target="search" />

            <main className="flex-grow">
                <SearchContent />
            </main>

            {/* Floating WhatsApp Action */}
            <WhatssapIcon />

            <Footer />
        </div>
    )
}

export default SearchPage;